import { Modal, Typography } from '@mui/material';
import { Box } from '@mui/system';

import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import IosShareIcon from '@mui/icons-material/IosShare';
import { useEffect, useState } from 'react';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Install = () => {
  const [promptedBefore, setPromptedBefore] = useState(false);

  const hasBeenPromptedBefore = localStorage.getItem('installPopupShown');

  useEffect(() => {
    setPromptedBefore(hasBeenPromptedBefore);
  }, [hasBeenPromptedBefore]);

  const saveClose = () => {
    localStorage.setItem('installPopupShown', true);
    setPromptedBefore(false);
  };

  return (
    <Modal
      open={!promptedBefore}
      onClose={saveClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Installer fotballyst på telefonen <InstallMobileIcon />
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          1. Trykk på dele ikonet: <IosShareIcon />
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          2. Gå til meny i nettleseren og velg "Legg til på Hjem-skjermen".
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Du vil nå kunne bruke fotballyst som en app på telefonen 🙌 🎉
        </Typography>
      </Box>
    </Modal>
  );
};

export default Install;
